import useColors from './useColor';

export default useColors;
